<template>
  <div class="px-2 pb-1">
    <b-row class="align-items-center pb-1">
      <b-col>
        <input-field
          name="drm"
          label="DRM"
          label-position="top"
          info-position="label"
        >
          <div>
            {{ useDrm ? 'Enabled' : 'Disabled' }}
          </div>
        </input-field>
        <span />
      </b-col>
    </b-row>
    <transition-group
      name="fade"
      tag="div"
    >
      <template v-if="useDrm">
        <b-row key="firstRow">
          <b-col
            cols="12"
            sm="6"
          >
            <input-field
              name="drm-provider"
              label="DRM Provider"
              label-position="top"
              info-position="label"
            >
              <div>
                {{ drmProvider }}
              </div>
            </input-field>
          </b-col>
          <b-col
            v-if="
              groupDrm.shakaPackagerKeyProviderType ===
                drmSettings.rawKey.rawKeyId
            "
            cols="12"
            sm="6"
          >
            <input-field
              name="drm-rawLabels"
              label="Raw Key Label"
              label-position="top"
              info-position="label"
            >
              <div>
                {{ groupDrm.label || '-' }}
              </div>
            </input-field>
          </b-col>
          <b-col
            v-else-if="
              groupDrm.shakaPackagerKeyProviderType ===
                drmSettings.widevineAlgorithm.widevineId
            "
            cols="12"
            sm="6"
          >
            <input-field
              name="drm-widevineAlgorithms"
              label="Widevine Algorithms"
              label-position="top"
              info-position="label"
            >
              <div>
                {{ algorithm }}
              </div>
            </input-field>
          </b-col>
          <b-col v-else />
        </b-row>
        <b-row key="secondRow">
          <b-col
            cols="12"
            sm="6"
          >
            <input-field
              name="drm-protection_schema"
              label="Protection Schema"
              label-position="top"
              info-position="label"
            >
              <div>
                {{ protectionSchema }}
              </div>
            </input-field>
          </b-col>
          <b-col
            cols="12"
            sm="6"
          >
            <input-field
              name="drm-clear_lead"
              label="Clear Lead"
              label-position="top"
              info-position="label"
            >
              <div>
                {{ groupDrm.clearLead }}
              </div>
            </input-field>
          </b-col>
        </b-row>
      </template>
    </transition-group>
  </div>
</template>

<script>
import InputField from '@/components/form/InputField.vue'

export default {
  name: 'DRMSettings',
  components: {
    InputField,
  },
  props: {
    hasDrm: {
      type: Boolean,
      required: true,
    },
    groupDrm: {
      type: Object,
      required: true,
    },
    drmSettings: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      useDrm: false,
    }
  },
  computed: {
    drmProvider() {
      return (
        this.drmSettings.providers.find(
          o => o.id === this.groupDrm.shakaPackagerKeyProviderType,
        )?.name || '-'
      )
    },
    algorithm() {
      return (
        this.drmSettings.widevineAlgorithm.algorithms.find(
          o => o.id === this.groupDrm.encryptionAlgorithmType,
        )?.type || '-'
      )
    },
    protectionSchema() {
      return (
        this.groupDrm?.protectionSchemaOptions.find(
          o => o.id === this.groupDrm.protectionSchemaType,
        )?.value || '-'
      )
    },
  },
  watch: {
    useDrm(val) {
      this.$emit('useDrm', val)
    },
  },
  created() {
    this.useDrm = this.hasDrm
  },
  methods: {
    getNameOptions(arr) {
      return arr.map(i => ({ text: i.name, value: i.id }))
    },
    getTypeOptions(arr) {
      return arr.map(i => ({ text: i.type, value: i.id }))
    },
  },
}
</script>
